module.exports = __webpack_public_path__ + "img/正面.3efceaea.jpg";